import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { createTestimonial, updateTestimonial, deleteTestimonial, getTestimonials } from '../api/auth/authService';

function Testimonialupdate() {
    const [data, setData] = useState([]);
    const [values, setValues] = useState({
        image: null,
        name: '',
        designation: '',
        description: ''
    });
    const [editingId, setEditingId] = useState(null);

    // Fetch data on component mount
    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            const response = await getTestimonials();
            setData(response);
        } catch (error) {
            console.error('Error fetching testimonials:', error);
            Swal.fire('Error', 'Failed to fetch testimonials.', 'error');
        }
    };

    const handleChanges = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setValues((prev) => ({
                ...prev,
                image: files[0]
            }));
        } else {
            setValues((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('image', values.image);
        formData.append('name', values.name);
        formData.append('designation', values.designation);
        formData.append('description', values.description);
        formData.append('date', new Date().toISOString().split('T')[0]);

        try {
            if (editingId) {
                await updateTestimonial(editingId, formData);
                Swal.fire('Updated!', 'Testimonial updated successfully!', 'success');
                setEditingId(null);
            } else {
                await createTestimonial(formData);
                Swal.fire('Added!', 'Testimonial added successfully!', 'success');
            }

            setValues({
                image: null,
                name: '',
                designation: '',
                description: ''
            });
            document.getElementById('testimonialImage').value = '';
            fetchTestimonials();
        } catch (error) {
            console.error('Error submitting testimonial:', error);
            Swal.fire('Error', 'Failed to submit testimonial data.', 'error');
        }
    };

    const handleEditClick = (item) => {
        setValues({
            image: null, // You cannot preload files into an input
            name: item.name,
            designation: item.designation,
            description: item.description
        });
        setEditingId(item.id);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will permanently delete the testimonial.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteTestimonial(id);
                    setData((prev) => prev.filter(item => item.id !== id));
                    Swal.fire('Deleted!', 'The testimonial has been deleted.', 'success');
                } catch (error) {
                    Swal.fire('Error!', 'Could not delete testimonial.', 'error');
                    console.error('Delete error:', error);
                }
            }
        });
    };

    useEffect(() => {
        fetchTestimonials();
    }, [editingId]); // So updated list appears right after edit

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '215px' }}>
                <div className="container-fluid">
                    <h5 className="page-title mt-3">Testimonial Update</h5>
                    <div className="row mt-3">
                        <div className="col-md-8">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="testimonialImage" className="form-label">Image</label>
                                    <input type="file" name="image" className="form-control" id="testimonialImage" onChange={handleChanges} required={!editingId} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" name="name" className="form-control" id="name" placeholder="Enter Name" onChange={handleChanges} value={values.name} required={!editingId} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="designation" className="form-label">Designation</label>
                                    <input type="text" className="form-control" id="designation" name="designation" placeholder="Enter Designation" onChange={handleChanges} value={values.designation} required={!editingId} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label">Description</label>
                                    <textarea className="form-control" id="description" name="description" rows={3} placeholder="Enter Description" onChange={handleChanges} value={values.description} required={!editingId} />
                                </div>
                                <button type="submit" className="btn btn-primary">{editingId ? 'Update' : 'Add'} Testimonial</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-10 mt-5" style={{ marginLeft: '200px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Description</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <img
                                            src={item.imageBytes ? `data:image/jpeg;base64,${item.imageBytes}` : 'https://via.placeholder.com/100'}
                                            alt={item.name}
                                            style={{ width: '100px', height: 'auto', borderRadius: '5px' }}
                                        />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{item.designation}</td>
                                    <td>{item.description}</td>
                                    <td>{item.date || 'N/A'}</td>
                                    <td style={{ width: '15%' }}>
                                        <button className="btn btn-primary me-2" onClick={() => handleEditClick(item)}>Edit</button>
                                        <button className="btn btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">No testimonials found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Testimonialupdate;